import { Text, Td } from '@chakra-ui/react';
import { GuideStep } from '~/monolith-api';

type ImportantStepsProps = {
   importantStep: GuideStep;
};

export function ImportantStep({ importantStep }: ImportantStepsProps) {
   return (
      <Td border="var(--chakra-colors-gray-300) solid 1px" width="33%">
         <Text as="b">
            {importantStep.orderby}. {importantStep.title}
         </Text>
      </Td>
   );
}
